import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Controller } from "react-hook-form";
import {IDaCheckboxFieldProps} from "./types";

export const DaCheckboxField: React.FC<IDaCheckboxFieldProps<any>> = (
    {
        control,
        name,
        label,
        disabled = false,
        size = "medium",
        defaultChecked = false,
        labelPlacement = "end",
    } : IDaCheckboxFieldProps<any>

) => {

  return (
      <Controller
          name={name}
          control={control}
          render={({ field }) =>
              <FormControlLabel
                  {...field}
                  control={
                      <Checkbox
                          size={size}
                          // defaultChecked={defaultChecked}
                      />}
                  checked={field.value}
                  label={label}
                  labelPlacement={labelPlacement}
                  disabled={disabled}
              />
          }
        />
  );
};